'use strict';

wbApp.controller('ActionRegistrationCtrl', ['$scope', '$translate', '$modal', 'securitySvc', 'tenantSettingSvc', 'actionDetailSvc', 'notificationSvc', 'onlinePaymentsSvc', 'urlUtils',
    'studentSvc', 'employeeSvc', 'courseSvc', 'classroomSvc', '$filter', 'courseRegistrationSvc', 'messageBoxSvc',
    function ($scope, $translate, $modal, securitySvc, tenantSettingSvc, actionDetailSvc, notificationSvc, onlinePaymentsSvc, urlUtils,
        studentSvc, employeeSvc, courseSvc, classroomSvc, $filter, courseRegistrationSvc, messageBoxSvc) {

        var courseID = urlUtils.getLastUrlPart();

        //var actionDetail = actionDetailSvc.getActionDetail();
        //actionDetail.$promise.then(function (result) {
        //    actionDetailSvc.setUpActionPrices(result.action, result.students);
        //    $scope.students = result.students;
        //    $scope.origStudents = angular.copy(result.students);
        //    validateConditionForBooking(result.students);
        //    prepareTabs();
        //    $scope.images = _.map(result.action.pictures, function (p) {
        //        return {
        //            thumb: p.imageUrl,
        //            img: p.imageUrl
        //        };
        //    });
        //});

        $scope.actionScheduleDesc = '';
        $scope.actionIsLoading = true;
        $scope.supportsOnlinePayment = false;
        $scope.userStudents = null;
        $scope.students = null;
        $scope.studentsAreLoading = true;
        $scope.employeeIsLoading = true;
        $scope.employee = {};
        $scope.classroom = { address: { location: {} } };
        $scope.isSaving = false;
        $scope.actionFeeeCapacity = 0;

        $scope.requireTermsAndConditionsAgreement = !!tenantSettingSvc.settings.requireTermsAndConditionsAgreement;
        $scope.requireTradeTermsAgreement = !!tenantSettingSvc.settings.requireTradeTermsAgreement;
        $scope.showNotes = !!tenantSettingSvc.settings.showNoteInEventRegistration;

        $scope.showTermsAgreement = $scope.requireTermsAndConditionsAgreement || $scope.requireTradeTermsAgreement;

        function validateConditionForBooking(students) {
            if (!securitySvc.isAuthenticated()) {
                $scope.serverError = { errors: [{ message: $translate.instant('TXT_ERROR_NOT_LOGGED_IN') }] };
            } else {
                if (!students.length) {
                    $scope.serverError = { errors: [{ message: $translate.instant('TXT_ERROR_NO_STUDENTS') }] };
                }
            }
        }


        function setUpScope(students) {

            $scope.origStudents = angular.copy(students);

            // Preselect student if only one is defined
            if (!!students && students.length == 1) {
                var student = students[0];
                if (student.isNew) {
                    student.attend = true;
                }
            }
        }

        function loadStudentRegs(refresh, registrationsLoadedCallback) {
            if ($scope.userStudents.length && (!$scope.students || refresh)) {
                $scope.students = courseRegistrationSvc.getAllForCourseAndUser(
                    securitySvc.loggedInUser().userID,
                    $scope.action,
                    $scope.userStudents,
                    true,
                    tenantSettingSvc.settings.courseInterestsSupport,
                    $scope.showLessonSelection);

                $scope.students.$promise.then(function () {
                    $scope.studentsAreLoading = false;
                    setUpScope($scope.students);
                    if (!!registrationsLoadedCallback) {
                        registrationsLoadedCallback($scope.students);
                    }
                });
            }
        }

        function loadData(registrationsLoadedCallback) {
            $scope.action = courseSvc.getByCourseID(courseID);
            $scope.action.$promise.then(function (action) {

                $scope.actionFeeeCapacity = Math.max(0, action.capacity - action.filled);

                $scope.supportsOnlinePayment = action.supportsOnlinePayment;
                $scope.preferOnlinePayments = action.preferOnlinePayments && action.supportsOnlinePayment;

                $scope.employee = employeeSvc.getBriefByEmployeeID(action.employeeID);
                $scope.employee.$promise.then(function () {
                    $scope.employeeIsLoading = false;
                });

                $scope.actionScheduleDesc = !!action.firstLesson
                    ? $filter('date')(action.firstLesson, 'd. M. y EEE HH:mm').toUpperCase() + 
                      ' - ' +
                      $filter('date')(action.firstLessonEndDate, 'HH:mm')
                    : '';

                $scope.images = _.map(action.pictures, function (p) {
                    return {
                        thumb: p.imageUrl,
                        img: p.imageUrl
                    };
                });

                if (securitySvc.isAuthenticated()) {
                    studentSvc.getCurrentAsync().$promise.then(function (students) {

                        $scope.userStudents = students;

                        validateConditionForBooking(students);

                        if (!students.length) {
                            $scope.students = [];
                            $scope.studentsAreLoading = false;
                        } else {
                            prepareTabs();
                            if (!!$scope.students) {
                                loadStudentRegs(true, registrationsLoadedCallback);
                            }
                        }
                    });
                } else {
                    $scope.students = [];
                    $scope.studentsAreLoading = false;

                    validateConditionForBooking(null); 
                }

                if ($scope.action.classroomID) {
                    classroomSvc.getAsync($scope.action.classroomID).then(function (data) {
                        angular.extend($scope.classroom, data);
                    });
                }

                $scope.actionIsLoading = false;
            });
        }


        $scope.allowShareOnFBForActions = tenantSettingSvc.settings.allowShareOnFBForActions;

      //  $scope.action = actionDetail.action;

        $scope.tabs = [{
            title: 'TXT_TAB_ACTION_DETAIL',
            template: 'actions/action-detail-tab.html',
            name: 'detail'
        }];

        $scope.tabs.activeTab = 0;

        var preparedTabsCalled = false;

        $scope.$watch('tabs.activeTab', function (newValue, oldValue) {

            if (preparedTabsCalled || !urlUtils.getQueryParams()['tabName']) {
                var tabName = $scope.tabs[newValue].name;
                urlUtils.setUrlParam("tabName", tabName);
            }

            if (newValue !== 0) {
                loadStudentRegs(false);
            }
        });

        function showOnlinePaymentResultsIfNeeded() {
            var onlinePaymentIDStr = urlUtils.getQueryParams()['onlinePaymentID'];
            if (!!onlinePaymentIDStr) {
                var onlinePaymentID = Number(onlinePaymentIDStr);

                onlinePaymentsSvc.getTransactionState(onlinePaymentID).$promise.then(
                    function (data) {
                        messageBoxSvc.showMessageDlg({
                            title: 'TXT_PAYMENT_RESULT',
                            message: onlinePaymentsSvc.getOnlinePaymentResultMessage(data),
                            buttons: [{
                                text: 'TXT_BTN_OK',
                                callback: function () {
                                    urlUtils.removeUrlParam('onlinePaymentID');
                                }
                            }]
                        });
                    });
            }
        }

        function switchToCorrectTab() {
            var tabName = urlUtils.getQueryParams()['tabName'];
            if (!!tabName) {
                // find correct tab
                var tabIndexToActivate = _.findIndex($scope.tabs, { name: tabName });
                if (tabIndexToActivate !== -1) {
                    if ($scope.tabs.activeTab !== tabIndexToActivate) {
                        $scope.tabs.activeTab = tabIndexToActivate;
                    }
                    showOnlinePaymentResultsIfNeeded();
                    return;
                }

            }

            $scope.tabs.activeTab = 0;
            urlUtils.setUrlParam("tabName", $scope.tabs[$scope.tabs.activeTab].name);
            showOnlinePaymentResultsIfNeeded();
        }

        function prepareTabs() {
            if (!$scope.serverError) {
                var idx = _.findIndex($scope.tabs, { name: 'book-event' });
                if (idx === -1) {
                    $scope.tabs.push({
                        title: 'TXT_TAB_BOOKING',
                        template: 'actions/book-action-tab.html',
                        name: 'book-event'
                    });
                }

                switchToCorrectTab();
            }

            preparedTabsCalled = true;
        }

        //$scope.onAttendanceCountChange = function (student) {
        //    actionDetailSvc.setUpActionPrices(actionDetail.action, $scope.students);
        //}

        $scope.shouldShowSaveButton = function () {
            if (!tenantSettingSvc.settings.allowClientActionRegistration) {
                return false;
            }

            if (!!$scope.serverError) {
                return false;
            }

            return $scope.tabs.activeTab === 1;
        }

        $scope.shouldEnableSaveButton = function () {
            if (!$scope.tabs.activeTab)
                return true;

            return !angular.equals($scope.origStudents, $scope.students);
        }

        $scope.onPrevBtnClick = function (returnUrl) {
            if ($scope.tabs.activeTab === 0) {
                window.location = returnUrl;
            } else {
                $scope.tabs.activeTab = 0;
            }
        }

        $scope.onNextClick = function () {

            if (!securitySvc.isAuthenticated()) {
                notificationSvc.advertiseLogin();
                return;
            }

            if ($scope.tabs.activeTab === 0) {
                $scope.tabs.activeTab = 1;
            }
        }

        $scope.confirmRegistration = { students: [] };

        $scope.onRegisterClick = function (returnUrl) {

            if (!$scope.tabs.activeTab) {
                $scope.tabs.activeTab += 1;
                return;
            }

            $scope.action.$promise.then(function (action) {
                if ($scope.students && $scope.students.$promise) {
                    $scope.students.$promise.then(function () {
                        $scope.confirmRegistration.students = _.filter($scope.students, { isNew: true, attend: true });
                        $scope.confirmRegistration.courseID = $scope.action.courseID;
                        $scope.confirmRegistration.description = actionDetailSvc.getConfirmRegistrationDescription(
                            $scope.students,
                            $scope.origStudents,
                            $scope.action);

                        $scope.confirmRegistration.requireTermsAndConditionsAgreement =
                            $scope.requireTermsAndConditionsAgreement && $scope.confirmRegistration.description.regDescription;
                        $scope.confirmRegistration.requireTradeTermsAgreement =
                            $scope.requireTradeTermsAgreement && $scope.confirmRegistration.description.regDescription;
                        $scope.confirmRegistration.showTermsAgreement = 
                            $scope.confirmRegistration.requireTermsAndConditionsAgreement || 
                            $scope.confirmRegistration.requireTradeTermsAgreement;
                        
                        $scope.confirmRegistration.requireTermsAndConditionsAgreementAccepted = 
                            !$scope.confirmRegistration.requireTermsAndConditionsAgreement;
                        $scope.confirmRegistration.requireTradeTermsAgreementAccepted = 
                            !$scope.confirmRegistration.requireTradeTermsAgreement;

                        confirmRegistrationDlg.$promise.then(function () {
                            confirmRegistrationDlg.show();
                        });
                    });
                }
            });
        }

        $scope.onPromoBuyClick = function (student) {
            actionDetailSvc.updatePriceDetails($scope.action, student);
        }

        $scope.onRegistrationConfirmClick = function (courseID, students, hideFn) {

            if (!$scope.confirmRegistration.requireTermsAndConditionsAgreementAccepted ||
                !$scope.confirmRegistration.requireTradeTermsAgreementAccepted) {

                var m = {
                    title: 'TXT_TITLE_INFORMATION',
                    message: 'TXT_AGREE_TO_TERMS_AND_CONDITIONS',
                    buttons: [{
                        text: 'TXT_BTN_OK'
                    }]
                };

                messageBoxSvc.showMessageDlg(m);

            } else {

                $scope.isSaving = true;

                var notificationConfig = {
                    sendEmailNotification: true,
                    sendSmsNotification: false
                };

                // Clear all errors
                _.forEach(students, function (student) {
                    student.markErrorAttendance.call(student, []);
                });

                courseRegistrationSvc.insertAll(
                    _.filter($scope.students, { attend: true }),
                    courseID,
                    notificationConfig,
                    2,
                    function () {
                        $scope.bookCourseTabContent = 'courses/book-course-tab-confirmation-content.html';
                        hideFn();
                        loadData(function (registrations) {

                            if ($scope.supportsOnlinePayment) {

                                var newRegistrations = _.intersectionBy(registrations, students, 'studentID');
                                var invoiceIDs = _.map(newRegistrations, 'invoiceID');
                                var price = _.sumBy(newRegistrations, 'price');

                                if (!!newRegistrations.length && price > 0) {
                                    if ($scope.preferOnlinePayments) {
                                        messageBoxSvc.showMessageDlg({
                                            title: 'TXT_TITLE_CONFIRM_ONLINE_PAYMENT',
                                            message: '<i class="fa fa-3x fa-credit-card text-success pull-right" aria-hidden="true"></i>' +
                                                $translate.instant('TXT_CONFIRM_INFORM_START_ONLINE_PAYMENT'),
                                            buttons: [{
                                                text: 'TXT_BTN_OK',
                                                callback: function () { return onlinePaymentsSvc.startOnlinePayment(invoiceIDs, price).$promise; }
                                            }]
                                        });
                                    }
                                    else {
                                        messageBoxSvc.showMessageDlg({
                                            title: 'TXT_TITLE_CONFIRM_ONLINE_PAYMENT',
                                            message: '<i class="fa fa-3x fa-credit-card text-success pull-right" aria-hidden="true"></i>' +
                                                $translate.instant('TXT_CONFIRM_CONFIRM_START_ONLINE_PAYMENT'),
                                            buttons: [{
                                                text: 'TXT_BTN_NO'
                                            }, {
                                                text: 'TXT_BTN_YES',
                                                callback: function () { return onlinePaymentsSvc.startOnlinePayment(invoiceIDs, price).$promise; }
                                            }]
                                        });
                                    }
                                }
                            }
                        });
                        $scope.isSaving = false;
                    }, function (errorResult) {
                        $scope.isSaving = false;
                    }
                );


                //actionDetailSvc.registerOnAction(
                //    courseID,
                //    students,
                //    success,
                //    error);

                //function success(result) {
                //    actionDetailSvc.setUpActionPrices(result.action, result.students);
                //    $scope.students = result.students;
                //    $scope.origStudents = angular.copy(result.students);
                //    validateConditionForBooking(result.students);
                //}

                //function error(result) {
                //    $scope.students = angular.copy($scope.origStudents);
                //}
            }
        }

        var confirmRegistrationDlg = $modal({
            templateUrl: 'actions/confirm-registration.html',
            show: false,
            scope: $scope
        });


        loadData();

    }
]);